import { render } from "./Assignment.vue?vue&type=template&id=359106dc&scoped=true"
import script from "./Assignment.vue?vue&type=script&lang=js"
export * from "./Assignment.vue?vue&type=script&lang=js"

import "./Assignment.vue?vue&type=style&index=0&id=359106dc&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Stage-Leadership_Admin_Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-359106dc"]])

export default __exports__